import Footer from '../../components/Footer/Footer';
import { Outlet } from 'react-router-dom';
import Header from '../../components/Header/Header';
const Layout = () => {
  return (
    <div className='wrapper'>
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};
export default Layout;
